import { render, staticRenderFns } from "./logisticsQuery.vue?vue&type=template&id=1abe30b4&scoped=true"
import script from "./logisticsQuery.vue?vue&type=script&lang=js"
export * from "./logisticsQuery.vue?vue&type=script&lang=js"
import style0 from "./logisticsQuery.vue?vue&type=style&index=0&id=1abe30b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abe30b4",
  null
  
)

export default component.exports